const getLifeInsuranceData = (type, returnOne, returnTwo, returnThree) => {
    if (type.toLowerCase().includes('target')) {
        return returnOne;
    }

    if (type.toLowerCase().includes('pvp')) {
        return returnTwo;
    }

    if (type.toLowerCase().includes('mma')) {
        return returnThree;
    }

    return false;
};

export default getLifeInsuranceData;
